import 'regenerator-runtime/runtime'
import useBSSLogger from '../hooks/useBSSLogger';
import getapiclient, { getwpclient } from '../lib/ajaxhelper';

const {logger} = useBSSLogger();

const getActives =  async () => {

    const {data} = await getapiclient().post(`modpag/actives`)

    logger.debug('metodi di pagamento attivi', data);

    return data;
}

/**
 * Ricevuto il carrello, lo associa all'anagrafica o alla sessione client.
 * Se per la stessa sessione client o anagrafica esiste un carrello in stato I va in modifica.
 * In presenza di anagrafica la sessione client viene ignorata.
 * Se il carrello è valido e pagato viene creato un ordine.
 * Viene richiamato allo step 3 e allo step 4. Solo allo step 4 vengono passati i pagamenti e i dati di fatturazione
 * Il webservice torna il carrello indicando per ogni preventivo la validità.
 * 
 * 
 * @param {*} req 
 * @returns 
 */
const pagamentoNonElettronico =  async (req) => {

    const {idmodpag, ...resto} = req;

    const body = {
        jsonobject: JSON.stringify(resto),
        idmodpag
    };

    const {data} = await getapiclient().post(`testataordine/paga`, body)

    logger.debug("creo ordine dal carrello", body);

    return data;  
}

export {getActives, pagamentoNonElettronico}